import React from "react";
import { useState } from "react";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";

const Ulalive = ({ children }) => {
    const [sidebar, setSidebar] = useState(false);
    return (
        <div className="h-screen pt-16 md:pt-[88px] pb-[60px] md:pb-0  bg-[#F3F5F6] overflow-hidden">
            <Header sidebar={sidebar} setSidebar={setSidebar} />
            <Sidebar
                sidebar={sidebar}
                setSidebar={setSidebar}
                children={children}
            />
        </div>
    );
};

export default Ulalive;
